package io.janni.wedding

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.lifecycle.ViewModelStore
import androidx.lifecycle.ViewModelStoreOwner
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.loadFromLocalStorage
import com.varabyte.kobweb.silk.theme.colors.saveToLocalStorage
import com.varabyte.kobweb.silk.theme.colors.systemPreference
import io.janni.wedding.di.appModule
import org.jetbrains.compose.web.dom.Style
import org.jetbrains.compose.web.dom.Text
import org.koin.compose.KoinApplication

private const val COLOR_MODE_KEY = "wedding:colorMode"

@InitSilk
fun initColorMode(ctx: InitSilkContext) {
    ctx.config.initialColorMode = ColorMode.LIGHT
}

@InitSilk
fun initStyles(ctx: InitSilkContext) {
    ctx.stylesheet.apply {
        registerStyleBase("html, body") { Modifier.fillMaxHeight() }
        registerStyleBase("body") { Modifier.scrollBehavior(ScrollBehavior.Smooth) }
    }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    KoinApplication(application = {
        modules(appModule)
    }) {
        // Provide ViewModelStoreOwner for ViewModels
        val viewModelStoreOwner = remember {
            object : ViewModelStoreOwner {
                override val viewModelStore = ViewModelStore()
            }
        }

        CompositionLocalProvider(LocalViewModelStoreOwner provides viewModelStoreOwner) {
            SilkApp {
                // Load Tangerine font
                Style {
                    """
                        @font-face {
                            font-family: 'Tangerine';
                            src: url('/Tangerine-Regular.ttf') format('truetype');
                            font-weight: normal;
                            font-style: normal;
                            font-display: swap;
                        }
                    """.trimIndent()
                }

                val colorMode = ColorMode.current
                LaunchedEffect(colorMode) {
                    colorMode.saveToLocalStorage(COLOR_MODE_KEY)
                }

                Surface(SmoothColorStyle.toModifier().fillMaxHeight()) {
                    content()
                }
            }
        }
    }
}
